import React from 'react';
import { Image } from 'react-native-web';
import {
  Android,
  icon_in_the_quick_action_bar_str,
  iMessage,
  keyboard_logo,
} from '../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  icon_promotion,
  img_action_bar_android,
  img_action_bar_page_ios,
  img_scr_onboarding_03_a_and,
} from '../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../FullPageSimulator';

//= ========================================================================
const QuickActionBarFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);

  const { promotion } = globJSON.configurations.keyboard;
  const myStyles = {
    hotkeyLogo: {
      position: 'absolute',
      width: 21,
      height: 21,
      marginLeft: 6,
      marginTop: simPlatform === Android ? 125 : 100,
      zIndex: 1,
    },
    cleanImageView: {
      width: 240,
      height: simPlatform === iMessage ? 200 : 217,
    },
    cleanImage: {
      marginTop: 85,
      width: 242,
      height: simPlatform === iMessage ? 270 : 215,
    },
    promotionIcon: {
      width: 16,
      height: 16,
      position: simPlatform === Android && 'absolute',
      marginTop: simPlatform === Android ? 125 : 102,
      marginLeft: simPlatform === Android ? 205 : 205,
    },
  };
  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={icon_in_the_quick_action_bar_str}
      cleanBackgroundImage={simPlatform === Android}
      WithImageBackground={simPlatform === Android ? img_scr_onboarding_03_a_and : img_action_bar_page_ios}
      hidePhoneHeadLine
      withOutPadding
      hideIcons
      withOutTopVerticalLine
      slideshowRefs={slideshowRefs}
      BackgroundColor="#fff"
    >
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.hotkeyLogo}
        source={img_stub}
      />
      {simPlatform === Android && (
        <Image
          fadeDuration={0}
          style={myStyles.cleanImage}
          source={img_action_bar_android}
        />
      )}
      {promotion.enable_promotion
            && (
            <Image
              fadeDuration={0}
              resizeMode="contain"
              style={myStyles.promotionIcon}
              source={icon_promotion}
            />
            )}
    </FullPageSimulator>
  );
};

export default QuickActionBarFP;
